module.exports = __webpack_public_path__ + "img/UOI291.7c6d9fb5.png";